import React from 'react';
import ReactDOM from 'react-dom/client';

import {
  AppAuth0Provider,
  AppQueryClientProvider,
  AppRouterProvider,
  AppThemeProvider,
} from './providers';
import './styles/globals.css';

ReactDOM.createRoot(document.querySelector('#root')!).render(
  <React.StrictMode>
    <AppAuth0Provider>
      <AppQueryClientProvider>
        <AppThemeProvider>
          <AppRouterProvider />
        </AppThemeProvider>
      </AppQueryClientProvider>
    </AppAuth0Provider>
  </React.StrictMode>,
);
